exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.KioskCenteredLayout__centeredLayout___2HxuHQZ6 {\n  height: calc(100vh - 115px);\n  min-height: calc(1920px - 115px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n.KioskCenteredLayout__kioskHeadless___59aozcwZ {\n  height: 100vh;\n  min-height: 1920px;\n}\n", ""]);
// Exports
exports.locals = {
	"centeredLayout": "KioskCenteredLayout__centeredLayout___2HxuHQZ6",
	"kioskHeadless": "KioskCenteredLayout__kioskHeadless___59aozcwZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/layouts/KioskCenteredLayout.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = fzn5
// module chunks = 3